"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const shadows = {
  normal: '0 0 20px rgba(0,0,0,0.07)',
  hover: '0 0 20px rgba(0,0,0,0.07)',
  tableRowHover: '0px 0px 10px 0px rgba(0, 0, 0, 0.2)',
  empty: 'none'
};
var _default = shadows;
exports.default = _default;